import * as React from "react";
import { FieldFacets, Filter } from "../../api";
import { FieldHelper } from "../utils/FieldHelper";
import { useSearchParams } from "react-router-dom";
import { URL_HELPER } from "../../App";

interface IFilterComponent {
    fieldFacets: FieldFacets;
}

export const FilterComponent: React.FC<IFilterComponent> = ({fieldFacets}) => {

    const [searchParams, setSearchParams] = useSearchParams();

    function getParams(): Filter[] {
        const filters = searchParams.get("filters");
        if (!filters) {
            return [];
        }
        return URL_HELPER.parseFilters(filters);
    }

    function onChange(event: React.FormEvent<HTMLSelectElement>) {
        // merge with existing filters
        const params = getParams();
        const newParams = params.filter(
            (param) => param.fieldId !== fieldFacets.id
        );
        if (event && event.currentTarget.value) {
            newParams.push({
                fieldId: fieldFacets.id,
                value: event.currentTarget.value,
            });
            event.currentTarget.classList.remove('is-default')
        } else {
            event.currentTarget.classList.add('is-default')
        }
        setSearchParams((params) => {
            params.set(
                "filters",
                newParams
                    .map((param) => param.fieldId + ":" + param.value)
                    .join(";")
            );
            params.set("page", "0");
            return params;
        });
    }

    function getValueFromParams() {
        return getParams()
            .filter((param) => param.fieldId === fieldFacets.id)
            .map((param) => param.value)
            .join();
    }

    return (
        <div className="form-group">
            <label htmlFor={fieldFacets.id} className="w-100 font-weight-bold">
                {FieldHelper.getPrettyName(fieldFacets.id)}
            </label>
            <select
                id={fieldFacets.id}
                name={fieldFacets.id}
                value={getValueFromParams()}
                onChange={onChange}
                className={getValueFromParams() ? 'form-control w-100' : 'form-control w-100 is-default'}
                >
                <option value="">Please select</option>
                {fieldFacets.facets?.map((facet) => {
                    return (
                        <option key={facet.id} value={facet.id}>
                            {facet.label + " (" + facet.count + ")"}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};
export default FilterComponent;
